export const Prices = [
    {
        id: 0,
        name: "₹0 to ₹500",
        array: [0, 500]
    },
    {
        id: 1,
        name: "₹500 to ₹1000",
        array: [500, 1000]
    },
    {
        id: 2,
        name: "₹1000 to ₹1500",
        array: [1000, 1500]
    },
    {
        id: 3,
        name: "₹1500 to ₹2000",
        array: [1500, 2000]
    },
    {
        id: 4,
        name: "₹2000 to ₹2500",
        array: [2000, 2500]
    },
    {
        id: 5,
        name: "₹2500 or more",
        array: [2500, 10000]
    }

]